(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["core-values-showcase"] && !Shopify.designMode) return;
  try {
    
  function initCoreValuesShowcase(root = document) {
    const sections = root.querySelectorAll('[data-core-values-showcase]');

    sections.forEach((section) => {
      if (section.dataset.coreValuesInitialized === 'true') return;
      section.dataset.coreValuesInitialized = 'true';

      const controller = new AbortController();
      const { signal } = controller;
      const viewport = section.querySelector('[data-core-values-viewport]');
      const cards = Array.from(section.querySelectorAll('[data-core-values-card]'));

      if (!viewport || cards.length === 0) return;

      const mobileMedia = window.matchMedia('(max-width: 989px)');
      const autoplayEnabled = section.dataset.mobileAutoplay === 'true';
      const autoplayInterval = Math.max(Number(section.dataset.mobileAutoplayInterval || 4), 2) * 1000;
      let activeCard = cards.find((card) => card.dataset.defaultActive === 'true') || cards[0];
      let autoplayTimer = null;
      let autoplayResumeTimer = null;

      const centerCard = (card, smooth = false) => {
        if (!mobileMedia.matches || !card) return;

        card.scrollIntoView({
          behavior: smooth ? 'smooth' : 'auto',
          inline: 'center',
          block: 'nearest',
        });
      };

      const setActive = (card, { center = false, smooth = false } = {}) => {
        if (!card) return;

        activeCard = card;
        cards.forEach((item) => item.classList.toggle('is-active', item === card));

        if (center) {
          centerCard(card, smooth);
        }
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const clearResumeTimer = () => {
        if (autoplayResumeTimer) {
          window.clearTimeout(autoplayResumeTimer);
          autoplayResumeTimer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();
        clearResumeTimer();

        if (!autoplayEnabled || !mobileMedia.matches || cards.length < 2) return;

        autoplayTimer = window.setInterval(() => {
          const currentIndex = Math.max(cards.indexOf(activeCard), 0);
          const nextCard = cards[(currentIndex + 1) % cards.length];
          setActive(nextCard, { center: true, smooth: true });
        }, autoplayInterval);
      };

      const pauseAutoplay = () => {
        if (!autoplayEnabled) return;

        stopAutoplay();
        clearResumeTimer();

        if (!mobileMedia.matches || cards.length < 2) return;

        autoplayResumeTimer = window.setTimeout(() => {
          startAutoplay();
        }, autoplayInterval);
      };

      cards.forEach((card) => {
        card.addEventListener(
          'mouseenter',
          () => setActive(card),
          { signal }
        );
        card.addEventListener(
          'focusin',
          () => {
            setActive(card, { center: true });
            pauseAutoplay();
          },
          { signal }
        );
        card.addEventListener(
          'click',
          () => {
            setActive(card, { center: true, smooth: true });
            pauseAutoplay();
          },
          { signal }
        );
      });

      viewport.addEventListener(
        'touchstart',
        () => {
          pauseAutoplay();
        },
        { passive: true, signal }
      );

      viewport.addEventListener(
        'pointerdown',
        () => {
          pauseAutoplay();
        },
        { passive: true, signal }
      );

      requestAnimationFrame(() => {
        setActive(activeCard, { center: true });
        startAutoplay();
      });

      window.addEventListener(
        'resize',
        () => {
          centerCard(activeCard);
          startAutoplay();
        },
        { signal }
      );

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            stopAutoplay();
            clearResumeTimer();
          } else {
            startAutoplay();
          }
        },
        { signal }
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target?.contains(section) || event.target === section) {
            stopAutoplay();
            clearResumeTimer();
            controller.abort();
          }
        },
        { signal }
      );
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initCoreValuesShowcase();
    },
    { once: true }
  );

  document.addEventListener('shopify:section:load', (event) => {
    initCoreValuesShowcase(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-showcase"] && !Shopify.designMode) return;
  try {
    
  function initInstagramVideoCarousel(root = document) {
    const sections = root.querySelectorAll('[data-instagram-video-carousel]');

    sections.forEach((section) => {
      if (section.dataset.instagramCarouselInitialized === 'true') return;
      section.dataset.instagramCarouselInitialized = 'true';

      const viewport = section.querySelector('[data-carousel-viewport]');
      const track = section.querySelector('[data-carousel-track]');
      const slides = Array.from(section.querySelectorAll('[data-carousel-slide]'));
      const prevButton = section.querySelector('[data-carousel-prev]');
      const nextButton = section.querySelector('[data-carousel-next]');
      const mobileDots = Array.from(section.querySelectorAll('[data-carousel-dot-mobile]'));
      const desktopDots = Array.from(section.querySelectorAll('[data-carousel-dot-desktop]'));

      if (!viewport || !track || slides.length === 0) return;

      const desktopMedia = window.matchMedia('(min-width: 990px)');
      const visibleDesktop = Math.max(Number(section.dataset.visibleDesktop || 1), 1);
      const visibleMobile = Math.max(Number(section.dataset.visibleMobile || 1), 1);
      const autoplayDesktop = section.dataset.autoplayDesktop === 'true';
      const autoplayMobile = section.dataset.autoplayMobile === 'true';
      const autoplayInterval = Math.max(Number(section.dataset.autoplayInterval || 4), 2) * 1000;
      const pauseOnHover = section.dataset.pauseOnHover === 'true';

      let currentIndex = 0;
      let autoplayTimer = null;
      let resumeTimer = null;
      let touchStartX = null;

      const getVisibleCount = () => {
        return desktopMedia.matches ? visibleDesktop : visibleMobile;
      };

      const getPageCount = () => {
        return Math.max(slides.length - getVisibleCount() + 1, 1);
      };

      const getCurrentDots = () => {
        return desktopMedia.matches ? desktopDots : mobileDots;
      };

      const updateDots = () => {
        [mobileDots, desktopDots].forEach((dotGroup) => {
          dotGroup.forEach((dot, dotIndex) => {
            const isActive = dotIndex === currentIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        });
      };

      const updateControls = () => {
        const shouldDisable = getPageCount() <= 1;
        if (prevButton) prevButton.disabled = shouldDisable;
        if (nextButton) nextButton.disabled = shouldDisable;
      };

      const updatePosition = (smooth = true) => {
        const firstSlide = slides[0];
        if (!firstSlide) return;

        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
        const slideStep = firstSlide.getBoundingClientRect().width + gap;
        const maxTranslate = Math.max(track.scrollWidth - viewport.clientWidth, 0);
        const requestedTranslate = currentIndex * slideStep;
        const translate = Math.min(requestedTranslate, maxTranslate);

        track.style.transition = smooth ? 'transform 340ms ease' : 'none';
        track.style.transform = `translate3d(-${translate}px, 0, 0)`;

        updateDots();
        updateControls();
      };

      const setIndex = (nextIndex, smooth = true) => {
        const pageCount = getPageCount();
        if (pageCount <= 1) {
          currentIndex = 0;
        } else if (nextIndex < 0) {
          currentIndex = pageCount - 1;
        } else if (nextIndex >= pageCount) {
          currentIndex = 0;
        } else {
          currentIndex = nextIndex;
        }

        updatePosition(smooth);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const clearResumeTimer = () => {
        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      };

      const shouldAutoplay = () => {
        if (getPageCount() <= 1) return false;
        return desktopMedia.matches ? autoplayDesktop : autoplayMobile;
      };

      const startAutoplay = () => {
        stopAutoplay();
        clearResumeTimer();

        if (!shouldAutoplay()) return;

        autoplayTimer = window.setInterval(() => {
          setIndex(currentIndex + 1, true);
        }, autoplayInterval);
      };

      const pauseAutoplay = () => {
        stopAutoplay();
        clearResumeTimer();

        if (!shouldAutoplay()) return;

        resumeTimer = window.setTimeout(() => {
          startAutoplay();
        }, autoplayInterval);
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          setIndex(currentIndex - 1, true);
          pauseAutoplay();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          setIndex(currentIndex + 1, true);
          pauseAutoplay();
        });
      }

      [mobileDots, desktopDots].forEach((dotGroup) => {
        dotGroup.forEach((dot) => {
          dot.addEventListener('click', () => {
            setIndex(Number(dot.dataset.slideIndex || 0), true);
            pauseAutoplay();
          });
        });
      });

      viewport.addEventListener(
        'touchstart',
        (event) => {
          if (!event.touches || event.touches.length === 0) return;
          touchStartX = event.touches[0].clientX;
          pauseAutoplay();
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        (event) => {
          if (touchStartX === null || !event.changedTouches || event.changedTouches.length === 0) return;

          const deltaX = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;

          if (Math.abs(deltaX) < 40) return;

          if (deltaX < 0) {
            setIndex(currentIndex + 1, true);
          } else {
            setIndex(currentIndex - 1, true);
          }
        },
        { passive: true }
      );

      if (pauseOnHover) {
        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);
      }

      section.addEventListener('focusin', pauseAutoplay);
      section.addEventListener('pointerdown', pauseAutoplay);

      window.addEventListener('resize', () => {
        const pageCount = getPageCount();
        if (currentIndex > pageCount - 1) {
          currentIndex = Math.max(pageCount - 1, 0);
        }
        updatePosition(false);
        startAutoplay();
      });

      if (desktopMedia.addEventListener) {
        desktopMedia.addEventListener('change', () => {
          const pageCount = getPageCount();
          if (currentIndex > pageCount - 1) {
            currentIndex = Math.max(pageCount - 1, 0);
          }
          updatePosition(false);
          startAutoplay();
        });
      }

      updatePosition(false);
      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', () => initInstagramVideoCarousel(document));
  document.addEventListener('shopify:section:load', (event) => initInstagramVideoCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
